/* Chroma PDP — behaviour for every chroma-* section.
   No dependencies. Each section is found by its data-cpdp-* root, so any section
   can be removed from the template without breaking the others. */
(function () {
  'use strict';
  // Every chroma section loads this file; run it once.
  if (window.__chromaPdp) return;
  window.__chromaPdp = true;

  var DESKTOP = window.matchMedia('(min-width: 900px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Shopify money format: {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}… */
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || '${{amount}}';
    function delimit(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision).split('.');
      var whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return fixed[1] ? whole + decimal + fixed[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  }

  function onScrollFrame(fn) {
    var queued = false;
    function tick() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fn(); });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
    return tick;
  }


  /* ------------------------------------------------------------------------
     Hero: price, tiers, add-ons, add to cart, sticky bar, delivery estimate
     ------------------------------------------------------------------------ */
  function initProduct(root) {
    var cfgEl = $('[data-cpdp-config]', root);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var money = function (c) { return formatMoney(c, cfg.moneyFormat); };

    var state = { tier: 0, addons: [] };
    var tiers = $$('[data-cpdp-tier]', root);
    var addons = $$('[data-cpdp-addon]', root);
    var qtyInput = $('[data-cpdp-qty]', root);

    function unit() {
      var t = tiers[state.tier];
      return t ? { qty: Number(t.dataset.qty) || 1, price: Number(t.dataset.price) || cfg.price }
               : { qty: 1, price: cfg.price };
    }

    function render() {
      var u = unit();
      var extraCents = state.addons.reduce(function (sum, btn) { return sum + (Number(btn.dataset.price) || 0); }, 0);
      var total = u.price + extraCents;
      var n = state.addons.length;
      var label = (n === 0 ? 'Add to Cart' : n === 1 ? 'Add Both to Cart' : 'Add All to Cart') + ' \u2022 ' + money(total);

      $$('[data-cpdp-atc-label]').forEach(function (el) { el.textContent = label; });
      $$('[data-cpdp-sticky-total]').forEach(function (el) { el.textContent = money(total); });

      var priceEl = $('[data-cpdp-price]', root);
      if (priceEl) priceEl.textContent = money(u.price);

      // compare-at scales with tier quantity so the Save figure stays honest
      var compare = cfg.compareAt * u.qty;
      var onSale = cfg.compareAt > cfg.price;
      var wasEl = $('[data-cpdp-compare]', root);
      if (wasEl) wasEl.textContent = onSale ? money(compare) : '';
      var saveEl = $('[data-cpdp-save]', root);
      if (saveEl) saveEl.textContent = onSale ? 'Save ' + money(compare - u.price) : '';

      if (qtyInput) qtyInput.value = u.qty;
    }

    tiers.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        state.tier = i;
        tiers.forEach(function (b, j) { b.setAttribute('aria-checked', j === i ? 'true' : 'false'); });
        render();
      });
    });

    addons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.textContent = on ? btn.dataset.labelOn : btn.dataset.labelOff;
        state.addons = addons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
        render();
      });
    });

    // Add to cart — main item (tier quantity) plus any selected add-ons in one request.
    function items() {
      var idField = $('[name="id"]', root);
      var list = [{ id: idField ? Number(idField.value) : cfg.variantId, quantity: unit().qty }];
      state.addons.forEach(function (b) { list.push({ id: Number(b.dataset.variant), quantity: 1 }); });
      return list;
    }

    // The main button and the sticky button both submit this form (sticky uses form="…").
    // With no add-ons the form is sent as-is; with add-ons it becomes an items[] payload.
    var form = $('form[data-cart-form]', root);
    if (form) {
      form._cpdpBody = function () {
        if (!state.addons.length) return new FormData(form);
        var fd = new FormData();
        items().forEach(function (it, i) {
          fd.append('items[' + i + '][id]', it.id);
          fd.append('items[' + i + '][quantity]', it.quantity);
        });
        return fd;
      };
    }

    // Sticky bar: shown once the main button leaves the top of the viewport,
    // hidden again while the bundle section (which has its own CTA) is on screen.
    var atc = $('[data-cpdp-atc]', root);
    var sticky = $('[data-cpdp-sticky]');
    if (atc && sticky) {
      onScrollFrame(function () {
        var passed = atc.getBoundingClientRect().bottom < 0;
        var bundle = $('[data-cpdp-bundle]');
        var bundleOn = false;
        if (bundle) {
          var r = bundle.getBoundingClientRect();
          bundleOn = r.top < window.innerHeight && r.bottom > 0;
        }
        var show = passed && !bundleOn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('cpdp-sticky-open', show && !DESKTOP.matches);
      });
    }

    // Delivery estimate in business days. Replace with real fulfilment data if available.
    var delivery = $('[data-cpdp-delivery]', root);
    if (delivery) {
      var addBiz = function (from, n) {
        var d = new Date(from.getTime());
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; }
        return d;
      };
      var fmt = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
      var ship = addBiz(new Date(), Number(delivery.dataset.processing) || 0);
      var a = fmt(addBiz(ship, Number(delivery.dataset.min) || 1));
      var b = fmt(addBiz(ship, Number(delivery.dataset.max) || 1));
      delivery.textContent = delivery.dataset.prefix + ' ' + (a === b ? a : a + ' \u2013 ' + b);
    }

    render();
    initGallery(root);
  }

  /* ------------------------------------------------------------------------
     Add to cart → Focal mini-cart drawer. Every ATC on the page is a
     <form data-cart-form> with id + quantity (or items[]) and a submit button.
     If the theme renames the drawer, header link or badge, change CART only.
     ------------------------------------------------------------------------ */
  var CART = {
    drawer: '#mini-cart',
    sectionId: 'mini-cart',
    toggle: 'a[aria-controls="mini-cart"]',
    count: 'cart-count'
  };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function refreshCart() {
    return fetch(ROOT + '?section_id=' + CART.sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(CART.drawer);
        var live = $(CART.drawer);
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        });
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$(CART.count).forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  function onCartSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-cart-form]')) return;
    e.preventDefault();
    var btn = e.submitter || $('[type="submit"]', form);
    if (!btn || btn.disabled) return;
    var label = $('[data-cpdp-atc-label]', btn) || btn;
    var original = label.textContent;
    var section = form.closest('section');
    var errEl = $('[data-cpdp-error]', form) || (section && $('[data-cpdp-error]', section));
    var body = form._cpdpBody ? form._cpdpBody() : new FormData(form);

    if (errEl) errEl.textContent = '';
    btn.disabled = true;
    label.textContent = 'Adding\u2026';

    fetch(ROOT + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || '');
          document.dispatchEvent(new CustomEvent('chroma:cart:added', { detail: { response: data } }));
        });
      })
      .then(refreshCart)
      .then(function () { return new Promise(function (r) { setTimeout(r, 300); }); })
      .then(function () {
        var toggle = $(CART.toggle);
        if (toggle) toggle.click();
        label.textContent = original;
        btn.disabled = false;
      })
      .catch(function (err) {
        if (errEl && err.message) errEl.textContent = err.message;
        label.textContent = 'Try again';
        setTimeout(function () { label.textContent = original; btn.disabled = false; }, 2000);
      });
  }
  document.addEventListener('submit', onCartSubmit);


  /* ------------------------------------------------------------------------
     Gallery + lightbox (native <dialog>: focus trap, Escape and inert page for free)
     ------------------------------------------------------------------------ */
  function initGallery(root) {
    var rail = $('[data-cpdp-rail]', root);
    var dialog = $('[data-cpdp-lightbox]', root);
    if (!rail || !dialog) return;

    var items = $$('[data-cpdp-zoom]', rail);
    var dots = $$('[data-cpdp-dot]', root);
    var slides = $$('[data-lb-slide]', dialog);
    var thumbs = $$('[data-lb-thumb]', dialog);
    var count = $('[data-lb-count]', dialog);
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        var on = j === current;
        s.classList.toggle('is-active', on);
        if (!on) $$('video', s).forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === current); });
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        show(Number(item.dataset.cpdpZoom) || 0);
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
    });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      $$('video', dialog).forEach(function (v) { v.pause(); });
    });
    $('[data-lb-close]', dialog).addEventListener('click', function () { dialog.close(); });
    $('[data-lb-prev]', dialog).addEventListener('click', function () { show(current - 1); });
    $('[data-lb-next]', dialog).addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });

    // mobile rail dots
    if (dots.length) {
      rail.addEventListener('scroll', function () {
        var i = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    }
  }


  /* ------------------------------------------------------------------------
     Benefits: tabs swap copy + background; background layer parallax
     ------------------------------------------------------------------------ */
  function initBenefits(root) {
    var tabs = $$('[data-tab]', root);
    var panels = $$('[data-panel]', root);
    var layers = $$('[data-layer]', root);
    var frame = $('[data-cpdp-frame]', root);

    function select(i) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      // a tab without its own image keeps the first image on screen
      var target = layers[i] && layers[i].dataset.hasImage === 'true' ? i : 0;
      layers.forEach(function (l, j) { l.classList.toggle('is-active', j === target); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var n = (i + d + tabs.length) % tabs.length;
        select(n);
        tabs[n].focus();
      });
    });
    if (tabs.length) select(0);

    // Travel is 75% of the layer's real overhang, in pixels, clamped to ±1 progress.
    if (!frame || !layers.length) return;
    onScrollFrame(function () {
      if (REDUCED.matches || !DESKTOP.matches) {
        layers.forEach(function (l) { l.style.transform = ''; });
        return;
      }
      var box = frame.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      var raw = 1 - 2 * ((box.top + box.height / 2) / (window.innerHeight + box.height));
      var progress = Math.max(-1, Math.min(1, raw));
      layers.forEach(function (l) {
        var overhang = Math.max(0, (l.offsetHeight - box.height) / 2);
        l.style.transform = 'translate3d(0,' + (progress * overhang * 0.75).toFixed(1) + 'px,0)';
      });
    });
  }


  /* ------------------------------------------------------------------------
     Built to spec: scroll position picks the active chapter; images get equal time
     ------------------------------------------------------------------------ */
  function initDetails(root) {
    var chapters = $$('[data-chapter]', root);
    var frames = $$('[data-frame]', root);
    var jumps = $$('[data-jump]', root);
    if (!chapters.length) return;
    var active = -1;


    function set(i) {
      if (i === active) return;
      active = i;
      frames.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
      jumps.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
    }
    onScrollFrame(function () {
      var line = window.innerHeight * 0.45;
      var top = chapters[0].getBoundingClientRect().top;
      var bottom = chapters[chapters.length - 1].getBoundingClientRect().bottom;
      var progress = Math.min(0.9999, Math.max(0, (line - top) / Math.max(1, bottom - top)));
      set(Math.floor(progress * chapters.length));
    });
    jumps.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var y = chapters[i].getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: y, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      });
    });
  }


  /* ------------------------------------------------------------------------
     "Show me" CTA (bundle and family add to cart run through onCartSubmit)
     ------------------------------------------------------------------------ */
  function initScrollToAtc() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cpdp-scroll-atc]');
      if (!btn) return;
      var atc = $('[data-cpdp-atc]');
      if (!atc) return;
      e.preventDefault();
      var y = atc.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: Math.max(0, y), behavior: REDUCED.matches ? 'auto' : 'smooth' });
    });
  }


  /* ------------------------------------------------------------------------
     Built to spec — mobile accordion. Delegated from document so it works no
     matter when the section renders (theme editor, lazy sections, init order).
     One chapter open at a time; tapping the open one closes it.
     ------------------------------------------------------------------------ */
  var CHAPTER_DESKTOP = window.matchMedia('(min-width: 900px)');
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-chapter-toggle]');
    if (!btn || CHAPTER_DESKTOP.matches) return;
    var ch = btn.closest('[data-chapter]');
    var list = ch && ch.parentElement;
    if (!ch || !list) return;
    e.preventDefault();
    var open = !ch.classList.contains('is-open');
    Array.prototype.forEach.call(list.querySelectorAll('[data-chapter]'), function (other) {
      other.classList.remove('is-open');
      var b = other.querySelector('[data-chapter-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (open) { ch.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
  });

  // Each section initialises on its own, once, so one failure can't stop the others.
  function each(scope, sel, fn) {
    var roots = Array.prototype.slice.call((scope && scope.querySelectorAll ? scope : document).querySelectorAll(sel));
    if (scope && scope !== document && scope.matches && scope.matches(sel)) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.__cpdpInit) return;
      root.__cpdpInit = true;
      try { fn(root); } catch (err) { console.error('[chroma-pdp] ' + sel, err); }
    });
  }
  var scrollBound = false;
  function init(scope) {
    each(scope, '[data-cpdp-product]', initProduct);
    each(scope, '[data-cpdp-benefits]', initBenefits);
    each(scope, '[data-cpdp-details]', initDetails);
    if (!scrollBound) { scrollBound = true; initScrollToAtc(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: re-run for a section when it is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
